export default __webpack_public_path__ + "static/media/rlogo.924d583b.png";